const ExpensesData = () => {
  const expensesData = [
    {
      id: 1,
      title: "Toilet Paper",
      amount: 94.12,
      date: new Date(2027, 3, 14),
    },
    {
      id: 2,
      title: "New TV",
      amount: 799.49,
      date: new Date(2027, 1, 9),
    },
    {
      id: 3,
      title: "Car Insurance",
      amount: 294.67,
      date: new Date(2026, 11, 23),
    },
    {
      id: 4,
      title: "New Desk (Wooden)",
      amount: 467.78,
      date: new Date(2026, 9, 11),
    },
    {
      id: 5,
      title: "Pen",
      amount: 39.99,
      date: new Date(2026, 4, 18),
    },
    {
      id: 6,
      title: "New Closet Door",
      amount: 354.12,
      date: new Date(2025, 12, 12),
    },
    {
      id: 7,
      title: "Beer Cooler",
      amount: 586.0,
      date: new Date(2025, 8, 3),
    },
    {
      id: 8,
      title: "Refrigirator",
      amount: 654.67,
      date: new Date(2025, 7, 14),
    },
    {
      id: 9,
      title: "Garbage Bags",
      amount: 73.89,
      date: new Date(2025, 6, 23),
    },
    {
      id: 10,
      title: "Large Cooking Pan",
      amount: 150.34,
      date: new Date(2025, 3, 11),
    },
    {
      id: 11,
      title: "Truck Rear Wheels",
      amount: 730.29,
      date: new Date(2025, 2, 18),
    },
    {
      id: 12,
      title: "Faucet",
      amount: 47.34,
      date: new Date(2024, 11, 12),
    },
    {
      id: 13,
      title: "Garagae Suplies",
      amount: 1173.37,
      date: new Date(2024, 7, 12),
    },
    {
      id: 14,
      title: "Dark Window Sheets",
      amount: 632.23,
      date: new Date(2023, 8, 13),
    },
    {
      id: 15,
      title: "Water Filter",
      amount: 323.34,
      date: new Date(2022, 9, 21),
    },
    {
      id: 16,
      title: "White Bed Sheets",
      amount: 130.23,
      date: new Date(2022, 6, 5),
    },
    {
      id: 17,
      title: "Rucksack",
      amount: 199.99,
      date: new Date(2021, 5, 12),
    },
    {
      id: 18,
      title: "Jump Ropes",
      amount: 89.99,
      date: new Date(2021, 11, 2),
    },
    {
      id: 19,
      title: "Mens Cotton Clothes",
      amount: 300.67,
      date: new Date(2021, 7, 17),
    },
    {
      id: 20,
      title: "Nail Gun",
      amount: 90.22,
      date: new Date(2021, 5, 12),
    },
  ];
  return expensesData;
};

export default ExpensesData;
// stateless
